
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'SubTitle'
})
export default class SubTitle extends Vue {
  @Prop(Object) titleData!: object
}
